<main id="main-content" class="main-content" role="main">
  <div class="page-header">
    <h1 class="page-title">Return Order</h1>
  </div>
  @if (hasContext) {
    <div class="account-field-container">
      <label class="account-info-label" for="accountNumber">
        {{ 'quoteSearchForm.label.accountNumber' | cxTranslate }}
      </label>
      <div id="account-info" class="account-info" role="textbox" aria-readonly="true">
        205174 - ABC SUPPLY #417 - MALVERN
      </div>
    </div>
  }
  @if (!hasContext) {
    <div class="account-number-wrapper">
      <label for="accountNumber">
        {{ 'quoteSearchForm.label.accountNumber' | cxTranslate }}
      </label>
      <ng-select id="accountNumber" [items]="customersDataList$ | async" [clearSearchOnAdd]="true" [closeOnSelect]="false"
        [multiple]="true" [placeholder]="'quoteSearchForm.label.accountNumber' | cxTranslate" clearAllText="Clear"
        [bindLabel]="'Text'" [virtualScroll]="true">
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <div class="row">
            <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
            {{item['Text']}}
          </div>
        </ng-template>
        <ng-template ng-multi-label-tmp let-items="items">
          @for (item of items | slice:0:1; track item) {
            <div class="ng-value">
              {{item['Text']}}
            </div>
          }
          @if (items.length > 1) {
            <div class="ng-value">
              <span class="ng-value-label">{{items.length - 1}} more...</span>
            </div>
          }
        </ng-template>
      </ng-select>
    </div>
  }
  <section class="search-filters" role="search" aria-labelledby="filter-heading">
    <form [formGroup]="returnOrdersSearchForm" (ngSubmit)="submitForm()">
      <div class="filter-row">
        <div class="filter-group">
          <label class="filter-label" for="rma-number">
            {{ 'orderReturnsSearchForm.label.rma' | cxTranslate }}
          </label>
          <input type="text" id="rma-number" class="filter-input"
            [placeholder]="'orderReturnsSearchForm.placeholder.rma' | cxTranslate" formControlName="rma" />
          </div>
          <div class="filter-group">
            <label class="filter-label" for="po-number">
              {{ 'orderReturnsSearchForm.label.poNumber' | cxTranslate }}
            </label>
            <input type="text" id="po-number" class="filter-input"
              [placeholder]="'orderReturnsSearchForm.placeholder.poNumber' | cxTranslate"
              formControlName="purchaseOrderNumber" />
            </div>
            <div class="filter-group">
              <label class="filter-label" for="status-filter">
                {{ 'orderReturnsSearchForm.label.filterByStatus' | cxTranslate }}
              </label>
              <ng-select id="status-filter" [items]="orderStatusList$ | async" [clearSearchOnAdd]="true"
                [closeOnSelect]="true" [placeholder]="'orderReturnsSearchForm.placeholder.status' | cxTranslate"
                clearAllText="Clear" formControlName="status" [bindLabel]="'Text'" [ngModel]="pStatus" [searchable]="false">
                <ng-template ng-option-tmp let-item="item">
                  <div>
                    {{ item['Text'] }}
                  </div>
                </ng-template>

              </ng-select>
            </div>

            <!-- ---------Product -->
            <div class="filter-group">
              <label class="filter-label" for="product-number">
                {{ 'orderReturnsSearchForm.label.productNumber' | cxTranslate }}
              </label>
              <input type="text" id="product-number" class="filter-input"
                [placeholder]="'orderReturnsSearchForm.placeholder.productNumber' | cxTranslate"
                formControlName="productNumber" />
              </div>

              <!-- Product Name -->
              <div class="filter-group">
                <label class="filter-label" for="product-name">
                  {{ 'orderReturnsSearchForm.label.productName' | cxTranslate }}
                </label>
                <input type="text" id="product-name" class="filter-input"
                  [placeholder]="'orderReturnsSearchForm.placeholder.productName' | cxTranslate"
                  formControlName="productName" />
                </div>
                <!-- -----------------brand------- -->
                @if (brandSalesShipToList$ | async; as items) {
                  <div class="filter-group">
                    <label class="filter-label" for="brand-filter">
                      {{ 'orderReturnsSearchForm.label.brand' | cxTranslate }}
                    </label>
                    <ng-select id="brand-filter" [items]="items.brand" [clearSearchOnAdd]="true" [closeOnSelect]="true"
                      [placeholder]="'orderReturnsSearchForm.placeholder.brand' | cxTranslate" clearAllText="Clear"
                      formControlName="brand" [bindLabel]="'name'" [ngModel]="pBrand" [searchable]="false" [disabled]="true">
                      <ng-template ng-option-tmp let-item="item">
                        <div>
                          {{ item['name'] }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                }
              </div>
              <!-- ---------------SiptoDestinato -->
              <div class="filter-row row-2">
                @if (shipToDestinationsList$ | async; as items) {
                  <div class="filter-group">
                    <label class="filter-label" for="ship-destination">
                      {{ 'orderReturnsSearchForm.label.shipTo' | cxTranslate }}
                    </label>
                    <ng-select id="ship-destination" [items]="items.shipTo" [clearSearchOnAdd]="true" [closeOnSelect]="true"
                      [placeholder]="'orderReturnsSearchForm.placeholder.shipTo' | cxTranslate" clearAllText="Clear"
                      formControlName="shipTo" bindLabel="labelDesc" [ngModel]="pShipTo" [virtualScroll]="true"
                      [searchable]="false" [disabled]="true">
                      <ng-template ng-option-tmp let-item="item">
                        <div>
                          {{ item['labelDesc'] }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                }

                <div class="datepicker-wrapper">
                  <label class="filter-label" for="date-from">
                    {{ 'orderReturnsSearchForm.label.from' | cxTranslate }}
                  </label>
                  <input id="date-from" class="filter-input res-input"
                    [placeholder]="'orderReturnsSearchForm.label.from' | cxTranslate" name="fromDate" ngbDatepicker
                    #fromDate="ngbDatepicker" formControlName="_startDate" [readonly]="true" [maxDate]="maxStartDate()"
                    (dateSelect)="onDateChange($event, 'fDate')" (click)="fromDate.toggle()" container="body" />
                    <i class="far fa-calendar-alt calendar-icon" (click)="fromDate.toggle()"></i>
                  </div>
                  <div class="datepicker-wrapper">
                    <label class="filter-label" for="date-to">
                      {{ 'orderReturnsSearchForm.label.to' | cxTranslate }}
                    </label>
                    <input id="date-to" class="filter-input res-input"
                      [placeholder]="'orderReturnsSearchForm.label.to' | cxTranslate" name="endDate" ngbDatepicker
                      #endDate="ngbDatepicker" formControlName="_endDate" [readonly]="true" [maxDate]="maxEndDate()"
                      (dateSelect)="onDateChange($event)" (click)="endDate.toggle()" container="body" />
                      <i class="far fa-calendar-alt calendar-icon" (click)="endDate.toggle()"></i>
                      @if (returnOrdersSearchForm.controls['_endDate'].errors) {
                        <div class="mt-25">
                          Please select to date
                        </div>
                      }
                    </div>
                  </div>

                  <!-- Search Actions -->
                  <div class="search-actions">
                    <button type="submit" [disabled]="isSearchDisabled$ | async" class="search-btn">
                      {{ 'button.search' | cxTranslate }}
                    </button>
                    <button type="button" (click)="resetForm()" class="reset-btn">
                      {{ 'button.reset' | cxTranslate }}
                    </button>
                  </div>
                </form>
              </section>
            </main>